var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4C13.3137 4 16 6.68629 16 10C16 13.3137 13.3137 16 10 16C6.68629 16 4 13.3137 4 10C4 6.68629 6.68629 4 10 4ZM13.0811 7.1875C12.8425 6.93756 12.4583 6.93759 12.2197 7.1875L9.13379 10.4209L7.78027 9.01465C7.54169 8.76515 7.15734 8.76581 6.91895 9.01562L6.42871 9.5293C6.19092 9.77848 6.19092 10.1932 6.42871 10.4424L8.69043 12.8125C8.92898 13.0624 9.32689 13.0624 9.56543 12.8125L13.5713 8.61426C13.8091 8.36508 13.8091 7.95035 13.5713 7.70117L13.0811 7.1875Z",
    fill: "#00866E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckG);
export default __webpack_public_path__ + "static/media/check-g.92968086482f41f36e4b06c82ebf2798.svg";
export { ForwardRef as ReactComponent };